export default "__VITE_ASSET__Do9Iv0Oq__"